import React from 'react';
import TemplatePage, { TemplateSection } from './TemplatePage';

// F3 (McKayla Loom "Current Site Feedback Part 1" t=0:56, ClickUp 86bah7dqn).
// Verbatim: "Who we serve, that's important... we probably want to say we
// serve advisory teams. I'll think on this, but we need something like this.
// What I don't know is what happens when you click on... more like marketing
// stuff, but I do think we need a who we serve."
//
// She owns the copy (plan Q4) and explicitly left the sub-navigation behaviour
// undecided, so the sections below are named but not linked anywhere.
export default function WhoWeServe() {
  return (
    <TemplatePage
      title="Who we serve"
      intro="A placeholder for the audiences Money Personality is built for. McKayla named advisory teams as the primary one; the rest of this page is hers to write."
    >
      <TemplateSection
        heading="Advisory teams"
        body="The audience McKayla named on 2026-08-20. Copy pending."
      />
      <TemplateSection
        heading="Individual advisors"
        body="Placeholder — included so the shape of the page is visible. Confirm whether this belongs here."
      />
      <TemplateSection
        heading="Firms and enterprises"
        body="Placeholder — confirm whether this is a separate audience or part of advisory teams."
      />
    </TemplatePage>
  );
}
